import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VendorMappingService } from './vendor-mapping.service';

interface PartVendorMapping {
  customerPartNo: string;
  internalPartNo: string;
  description: string;
  specification: string;
  manufacturer: string;
  uom: string;
  projectQty: number;
  vendors: {
    name: string;
    isSelected: boolean;
    targetPrice: number;
    currency: string;
    leadTime: number;
  }[];
}

@Component({
  selector: 'ngx-vendor-mapping',
  templateUrl: './vendor-mapping.component.html',
  styleUrls: ['./vendor-mapping.component.scss']
})
export class VendorMappingComponent implements OnInit {
  partVendorMappings: PartVendorMapping[] = [];
  filterForm: FormGroup;
  
  constructor(
    private vendorMappingService: VendorMappingService,
    private fb: FormBuilder
  ) {
    this.filterForm = this.fb.group({
      customerPartNo: [''],
      vendorName: [''],
      internalPartNo: ['']
    });
  }

  ngOnInit() {
    this.loadMappings();
    this.setupFiltering();
  }

  private loadMappings() {
    this.vendorMappingService.getPartVendorMappings().subscribe(
      mappings => {
        this.partVendorMappings = mappings;
      }
    );
  }

  private setupFiltering() {
    this.filterForm.valueChanges.subscribe(filters => {
      this.loadMappings(); // Reload base data
      this.applyFilters(filters);
    });
  }

  private applyFilters(filters: any) {
    if (!filters) return;

    this.partVendorMappings = this.partVendorMappings.filter(mapping => {
      const matchesPartNo = !filters.customerPartNo || 
        mapping.customerPartNo.toLowerCase().includes(filters.customerPartNo.toLowerCase());
      
      const matchesInternalPartNo = !filters.internalPartNo || 
        mapping.internalPartNo.toLowerCase().includes(filters.internalPartNo.toLowerCase());
      
      const matchesVendor = !filters.vendorName || 
        mapping.vendors.some(v => v.name.toLowerCase().includes(filters.vendorName.toLowerCase()));

      return matchesPartNo && matchesInternalPartNo && matchesVendor;
    });
  }

  saveVendorMappings() {
    const selectedMappings = this.partVendorMappings.map(mapping => ({
      customerPartNo: mapping.customerPartNo,
      selectedVendors: mapping.vendors
        .filter(v => v.isSelected)
        .map(v => ({
          name: v.name,
          targetPrice: v.targetPrice,
          currency: v.currency,
          leadTime: v.leadTime
        }))
    }));

    this.vendorMappingService.saveVendorMappings(selectedMappings).subscribe(
      () => {
        // Show success message
      },
      error => {
        // Handle error
      }
    );
  }

  toggleAllVendors(mapping: PartVendorMapping, selected: boolean) {
    mapping.vendors.forEach(vendor => vendor.isSelected = selected);
  }
}
